module.exports = __webpack_public_path__ + "static/media/arrow-up.7911518c.svg";